export default __webpack_public_path__ + "static/media/settings.2d5a4fbc.webp";